<div class="manager-loader-action">
  <div class="spinner-border text-primary w-55px h-55px"></div>
</div>
